import { IComponentController } from 'angular';
import { IMenuClass } from '../../../../../core/services/menu/menu.service';
import { IMonoOccurrence, IMonoOccurrenceOptions } from '../../../../../core/services/mono-occurrence.service';
import { IFormulaire, IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IMultiOccurrence, IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IProfil } from '../../../../../core/resources/profil.resource';
import { ICriteresSuggeresOptions } from '../../../../../core/components/ex-criteres-suggeres/ex-criteres-suggeres.controller';
import { IMenuItemActionClass } from '../../../../../core/services/menu/menu-item-action.service';
import { IMenuItemActionTelechargement, IMenuItemActionTelechargementClass } from '../../../../../core/services/menu/menu-item-action-telechargement.service';
import { IStateParamsService } from 'angular-ui-router';
import { IFilterLibelle } from '../../../../../core/filters/ex-libelle.filter';
import { IRoute } from '../../../../../core/interfaces/route.interface';

interface IPageRe0011 extends IComponentController {
    monoOccurrence: IMonoOccurrence;
    monoOccurrenceOptions: IMonoOccurrenceOptions;
    formulaireCie: IFormulaire;
    rslMultiOccurrenceOptions: IMultiOccurrenceOptions;
    rslMultiOccurrence: IMultiOccurrence;
    rsitMultiOccurrenceOptions: IMultiOccurrenceOptions;
    rsitMultiOccurrence: IMultiOccurrence;
    rsttMultiOccurrenceOptions: IMultiOccurrenceOptions;
    rsttMultiOccurrence: IMultiOccurrence;
    rdbtMultiOccurrenceOptions: IMultiOccurrenceOptions;
    rdbtMultiOccurrence: IMultiOccurrence;
    rdrtMultiOccurrenceOptions: IMultiOccurrenceOptions;
    rdrtMultiOccurrence: IMultiOccurrence;
    multiOccurrenceOptionsPartage: IMultiOccurrenceOptions;
    multiOccurrencePartage: IMultiOccurrence;
    optionsCriteresSuggeres: ICriteresSuggeresOptions;
    
}

/* @ngInject */
export default function Re0011Controller(
    MenuItemAction: IMenuItemActionClass,
    MenuItemActionTelechargement: IMenuItemActionTelechargementClass,
    Formulaire: IFormulaireClass,
    FormulaireItem: IFormulaireItemClass,
    Menu: IMenuClass,
    profil: IProfil,
    $stateParams: IStateParamsService,
    re0042Route: IRoute,
    exLibelleFilter: IFilterLibelle
) {
    const vm: IPageRe0011 = this;
    const menuItemTelechargement: IMenuItemActionTelechargement = new MenuItemActionTelechargement(
        'LBL_TELECHARGER',
        'BOUPDF',
        (data: any) => ({
            rslcleint: data.rslcleint
        }),
        {
            iconButton: true,
            icon: 'attach_file',
            hidden: (data: any) => !data.flgrwb
        }
    );
    vm.$onInit = $onInit;
    function $onInit() {

        vm.monoOccurrenceOptions = {
            noId: true,
            blocPanneauPageDefaut: 'RSL',
            id: profil.preferences.ciecleint,
            fonctions: {
                suiviModification: false,
                exportation: false
            }
        };
        vm.optionsCriteresSuggeres = {
            showFiltresInline: true,
            showAnnuler: false,
            iconFab: false
        };

        vm.formulaireCie = new Formulaire(
            [
                new FormulaireItem('rtocleint', {
                    required: true,
                    default: $stateParams.rtocleint,
                    ignoreEtat: !!$stateParams.rtocleint,
                    readonly: $stateParams.rtocleint
                }),
                new FormulaireItem('vaertostu', { hidden: true }),
                new FormulaireItem('rtodatcre', { hidden: true }),
                new FormulaireItem('mntde'),
                new FormulaireItem('mnta'),
                new FormulaireItem('ppacleint_de'),
                new FormulaireItem('ppacleint_a'),
                new FormulaireItem('temcleint', { titre: () => exLibelleFilter('TEMCLEINT', vm.multiOccurrence?.libelles) }),
                new FormulaireItem('strcleint', { titre: () => exLibelleFilter('STRCLEINT', vm.multiOccurrence?.libelles) }),
                new FormulaireItem('geccleint_anc', { titre: () => exLibelleFilter('GECCLEINT_ANC', vm.multiOccurrence?.libelles) }),
                new FormulaireItem('geccleint_nou', { titre: () => exLibelleFilter('GECCLEINT_NOU', vm.multiOccurrence?.libelles) }),
                new FormulaireItem('tagcleint', { titre: () => exLibelleFilter('TAGCLEINT', vm.multiOccurrence?.libelles) }),
                new FormulaireItem('rcecleint', { titre: () => exLibelleFilter('RCECLEINT', vm.multiOccurrence?.libelles) }),
                new FormulaireItem('imp'),
                new FormulaireItem('foncleint'),
                new FormulaireItem('flgimperr', { hidden: (data: any) => !data.rtodatcre })
            ],
            {
                largeurDefaut: 50
            }
        );

        vm.rslMultiOccurrenceOptions = {
            fonctions: {
                customCriteresSuggeres: true,
                criteresSuggeresVisibles: !$stateParams.rtocleint,
                reinitialiserOuvrirCriteres: true,
                effaceCriteres:true,
                nouveau: false,
                edition: false,
                supprime: false,
                activeRowOnClick: true // Ca prend ca pour refresh le panneau employé
            },
            criteresSuggeres: vm.formulaireCie,
            navigatePage: re0042Route.NAME,
            colonnesFixesGauche: [
                { nom: 'eplnummat', largeur: 100 },
                { nom: 'eplnomprn', largeur: 262 }
            ],
            colonnesVisibles: [
                { nom: 'rslmntcal', largeur: 126 },
                { nom: 'rslflglemina', largeur: 100 },
                { nom: 'rslflgrcebruzer', largeur: 100 },
                {
                    nom: 'rslmod',
                    largeur: 80,
                    menu: [
                        new MenuItemAction(
                            '',
                            'BOUMOD',
                            (data: any) => ({
                                rslflgmod: data.rslflgmod
                            }),
                            {
                                icon: 'check_box_outline_blank',
                                hidden: (data: any) => data.rslflgmod === 1,
                                successAction: () => {
                                    vm.rslMultiOccurrence.fetchDataList();
                                }
                            }
                        ),
                        new MenuItemAction(
                            '',
                            'BOUMOD',
                            (data: any) => ({
                                rslflgmod: data.rslflgmod
                            }),
                            {
                                icon: 'check_box_rounded',
                                hidden: (data: any) => data.rslflgmod !== 1,
                                successAction: () => {
                                    vm.rslMultiOccurrence.fetchDataList();
                                }
                            }
                        )
                    ]
                },
                {
                    nom: 'rslexc',
                    largeur: 80,
                    menu: [
                        new MenuItemAction(
                            '',
                            'BOUEXC',
                            (data: any) => ({
                                rslflgexc: data.rslflgexc
                            }),
                            {
                                icon: 'check_box_outline_blank',
                                hidden: (data: any) => data.rslflgexc === 1,
                                successAction: () => {
                                    vm.rslMultiOccurrence.fetchDataList();
                                }
                            }
                        ),
                        new MenuItemAction(
                            '',
                            'BOUEXC',
                            (data: any) => ({
                                rslflgexc: data.rslflgexc
                            }),
                            {
                                icon: 'check_box_rounded',
                                hidden: (data: any) => data.rslflgexc !== 1,
                                successAction: () => {
                                    vm.rslMultiOccurrence.fetchDataList();
                                }
                            }
                        )
                    ]
                },
                { nom: 'flgrwb', largeur: 140, menu: [menuItemTelechargement] }
            ],
            colonnesCachees: ['rslcleint', 'rslflgmod', 'rslflgexc'],
            actionsMoreLigne: new Menu([
                new MenuItemAction(
                    'LBL_BTN_DELRWB',
                    'BOUDELRWB',
                    (data: any) => ({
                        rslcleint: data.rslcleint
                    }),
                    {
                        messageConfirmation: 'BOUCONFIRM',
                        hidden: (data: any) => !data.flgrwb,
                        icon: 'delete'
                    }
                )
            ])
        };

        vm.rsitMultiOccurrenceOptions = {
            fonctions: {
                customCriteresSuggeres: true,
                reinitialiserOuvrirCriteres: true,
                effaceCriteres:true,
                edition: () => vm.rslMultiOccurrence.etatSelected.criteresSuggeresData.vaertostu === 'ENC',
                activeRowOnClick: false
            },
            actionsMore: new Menu([
                new MenuItemAction('LBL_BTN_REM', 'BOUREM', () => ({}), {
                    icon: 'edit',
                    formulaireConfirmationAction: {
                        lblTitre: 'LBL_REM_IMP',
                        lblConfirm: 'G_LBL_BTN_REM_IMP',
                        largeurFormulaire: 50,
                        formulaire: new Formulaire([new FormulaireItem('imp_old', { largeur: 100 }), new FormulaireItem('imp_new', { largeur: 100 })])
                    },
                    successAction: () => {
                        vm.rsitMultiOccurrence.fetchDataList();
                    },
                    hidden: () => vm.rslMultiOccurrence.etatSelected.criteresSuggeresData.vaertostu != 'ENC'
                })
            ]),
            colonnesFixesGauche: [
                { nom: 'eplnummat', largeur: 100 },
                { nom: 'eplnomprn', largeur: 262 }
            ],
            colonnesVisibles: [
                { nom: 'tagcod', largeur: 84 },
                { nom: 'tagdscabr', largeur: 210 },
                { nom: 'imp', largeur: 310 },
                { nom: 'msgerrimp', largeur: 262 },
                { nom: 'impini', largeur: 310 },
                { nom: 'aftcod', largeur: 105 },
                { nom: 'posnumdoc', largeur: 105 },
                { nom: 'lemcod', largeur: 117 },
                { nom: 'temcod', largeur: 120 },
                { nom: 'unocod', largeur: 105 },
                { nom: 'dernumdoc', largeur: 126 },
                { nom: 'drpnumdoc', largeur: 115 }
            ],
            colonnesFixesDroite: [
                { nom: 'rsimntcal', largeur: 126 },
                { nom: 'flgerr', largeur: 100 }
            ],
            formulaire: new Formulaire([new FormulaireItem('imp', { largeur: 50 }), new FormulaireItem('rsimntcal', { largeur: 50 })])
        };

        vm.rsttMultiOccurrenceOptions = {
            fonctions: {
                customCriteresSuggeres: true,
                reinitialiserOuvrirCriteres: true,
                effaceCriteres:true,
                activeRowOnClick: false
            },
            colonnesFixesGauche: [
                { nom: 'eplnummat', largeur: 100 },
                { nom: 'eplnomprn', largeur: 262 }
            ],
            colonnesVisibles: [
                { nom: 'ppacod', largeur: 84 },
                { nom: 'tagcod', largeur: 89 },
                { nom: 'tagdscabr', largeur: 280 },
                { nom: 'aftcod', largeur: 105 },
                { nom: 'posnumdoc', largeur: 89 },
                { nom: 'lemcod', largeur: 117 },
                { nom: 'temcod', largeur: 120 },
                { nom: 'unocod', largeur: 89 },
                { nom: 'dernumdoc', largeur: 126 },
                { nom: 'drpnumdoc', largeur: 89 },
                { nom: 'urgcod', largeur: 90 },
                { nom: 'urgdscabr', largeur: 280 },
                { nom: 'strcod', largeur: 90 },
                { nom: 'strdsc', largeur: 280 },
                { nom: 'geccodanc', largeur: 125 },
                { nom: 'gecdscanc', largeur: 280 },
                { nom: 'eeccodanc', largeur: 130 },
                { nom: 'rstsalanc', largeur: 115 },
                { nom: 'gecodnou', largeur: 137 },
                { nom: 'gecdscnou', largeur: 280 },
                { nom: 'eeccodnou', largeur: 145 },
                { nom: 'rstsalnou', largeur: 115 },
                { nom: 'vaersttyplig_dsc', largeur: 147 },
                { nom: 'tagcodret', largeur: 124 },
                { nom: 'tagdscabrret', largeur: 280 }
            ],
            colonnesFixesDroite: [
                { nom: 'rstqtecal', largeur: 115 },
                { nom: 'rstmntcal', largeur: 126 },
                { nom: 'rstflgexc', largeur: 100 }
            ]
        };

        vm.rdbtMultiOccurrenceOptions = {
            fonctions: {
                customCriteresSuggeres: true,
                reinitialiserOuvrirCriteres: true,
                effaceCriteres:true,
                activeRowOnClick: false
            },
            colonnesFixesGauche: [
                { nom: 'eplnummat', largeur: 100 },
                { nom: 'eplnomprn', largeur: 262 }
            ],
            colonnesVisibles: [
                { nom: 'ppacod', largeur: 84 },
                { nom: 'bqecod', largeur: 90 },
                { nom: 'bqedscabr', largeur: 280 },
                { nom: 'dbscod1', largeur: 110 },
                { nom: 'dbscod2', largeur: 110 },
                { nom: 'vaesystrsbqe_dsc', largeur: 210 }
            ],
            colonnesFixesDroite: [
                { nom: 'rdbqte', largeur: 140 },
                { nom: 'flgexc', largeur: 100 }
            ]
        };

        vm.rdrtMultiOccurrenceOptions = {
            fonctions: {
                customCriteresSuggeres: true,
                reinitialiserOuvrirCriteres: true,
                effaceCriteres:true,
                activeRowOnClick: false
            },
            colonnesFixesGauche: [
                { nom: 'eplnummat', largeur: 100 },
                { nom: 'eplnomprn', largeur: 262 }
            ],
            colonnesVisibles: [
                { nom: 'ppacod', largeur: 84 },
                { nom: 'rcecod', largeur: 84 },
                { nom: 'rcedscabr', largeur: 280 },
                { nom: 'rdrmntemp', largeur: 137 },
                { nom: 'rdrmntemr', largeur: 137 },
                { nom: 'rdrmntadm', largeur: 137 },
                { nom: 'rdrqteadm', largeur: 137 },
                { nom: 'cotcod', largeur: 133 },
                { nom: 'cotdsc', largeur: 280 },
                { nom: 'cdfcod', largeur: 115 },
                { nom: 'vaedsccdf', largeur: 184 },
                { nom: 'rdrflgbloprd', largeur: 114 },
                { nom: 'tagcod', largeur: 127 },
                { nom: 'tagdscabr', largeur: 280 },
                { nom: 'rdrmntseu', largeur: 139 },
                { nom: 'rdrmntadmemp', largeur: 155 },
                { nom: 'rdrmntadmemr', largeur: 166 },
                { nom: 'rdricvcod', largeur: 140 },
                { nom: 'rdricvdsc', largeur: 280 }
            ]
        };
}
}
